export const video_model = (show) => ({
    type: 'decesion',
    payload: { 
      show: show
    }
  });
